import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MoreVertical, Eye, Pencil, ShieldBan, CheckCircle } from "lucide-react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useAuth } from "../../hooks/AuthContext";

export const EmployeeList = ({ employees = [], statusFilter, onStatusChange }) => {
  
  const [openMenu, setOpenMenu] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;
var{user}=useAuth()
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".employee-dropdown")) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInactive = async (employeeId, user, onStatusChange) => {
    
    try {
      // Step 1: Ask for reason input
      const { value: remark } = await Swal.fire({
        title: "Reason of Inactivate",
        input: "textarea",
        inputLabel: "Please provide a reason for deactivating this employee",
        inputPlaceholder: "Enter reason here...",
        inputAttributes: {
          "aria-label": "Enter reason here",
        },
        inputValidator: (value) => {
          if (!value) {
            return "Reason is required!";
          }
        },
        showCancelButton: true,
        confirmButtonText: "Inactive",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });
  
      if (!remark) return; // User cancelled input
    
      // Step 2: API call
      const token = localStorage.getItem("token");
      const inactiveBy = user?.employeeProfile?._id;
  
      await axios.delete(`${API_URL}employees`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          employeeId: employeeId,
          status: "inactive",
          remark: remark,       // Reason of inactivation
          inactiveBy: inactiveBy // User who did it
        },
      });
  
      // Step 4: Success message
      onStatusChange?.();
      toast.success("Employee set to inactive successfully.");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to set employee as inactive."
      );
    }
  };

  const handleActivate = async (employeeId, user, onStatusChange) => {
    try {
      // Step 1: Ask for reason
      const { value: remark } = await Swal.fire({
        title: "Reason of Activate",
        input: "textarea",
        inputLabel: "Please provide a reason for activating this employee",
        inputPlaceholder: "Enter reason here...",
        inputAttributes: {
          "aria-label": "Enter reason here",
        },
        inputValidator: (value) => {
          if (!value) {
            return "Reason is required!";
          }
        },
        showCancelButton: true,
        confirmButtonText: "Submit",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });
  
      if (!remark) return; // User cancelled
  

      // Step 2: Send API request
      const token = localStorage.getItem("token");
      const activeBy = user?.employeeProfile?._id;
  
      await axios.delete(`${API_URL}employees`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          employeeId,
          status: "active",
          activeBy,
          remark,
        },
      });
  
      // Step 4: Show success
      toast.success("Employee activated successfully.");
      onStatusChange?.();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to activate employee."
      );
    }
  };


  // const formatEpochDate = (epoch) => {
  //   if (!epoch) return "—";
  //   return new Date(epoch * 1000).toLocaleDateString("en-IN", {
  //     day: "2-digit",
  //     month: "short",
  //     year: "numeric",
  //   });
  // };

  if (employees.length === 0) {
    return <p className="text-center text-gray-500 mt-8">No employees found.</p>;
  }

  return (
    <div className="overflow-x-auto bg-white rounded-lg shadow border">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Employee ID</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contact</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Location</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Designation</th>
            {employees.length > 0 && employees.some(emp => emp.remark) && (
  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
    Remark
  </th>
)}

            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {employees.map((employee) => (
            <tr key={employee._id} className="hover:bg-gray-50">
              <td className="px-6 py-4 text-sm font-semibold text-gray-700">
                <Link to={`/employee/view/${employee.employeeId}`} className="text-[#2C4E86] hover:underline">{employee.employeeId}</Link>
              </td>
              <td className="px-6 py-4 text-sm font-medium text-gray-900">{employee.name}</td>
              <td className="px-6 py-4 text-sm text-gray-600">
                <div>{employee.email}</div>
                <div className="text-xs text-gray-500">{employee.mobileNo}</div>
              </td>
              <td className="px-2 py-4 w-60 text-sm text-gray-600">{employee.correspondenceAddress}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{employee.designation}</td>
              <td className="px-6 py-4 text-sm text-gray-500">{employee.remark}</td>
              <td className="px-6 py-4 text-sm font-medium relative">
                <button onClick={() => setOpenMenu(openMenu === employee.employeeId ? null : employee.employeeId)} className="p-2 rounded-full hover:bg-gray-200">
                  <MoreVertical size={18} />
                </button>

                {openMenu === employee.employeeId && (
                <div className="absolute right-20 top-7 w-32 bg-white rounded-lg shadow-lg border z-10 employee-dropdown">
                {statusFilter === "active" ? (
                  <>
                    <Link
                      to={`/employee/view/${employee.employeeId}`}
                      className="flex items-center gap-4 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      <Eye size={16} className="text-gray-500" /> View
                    </Link>
              
                    <Link
                      to={`/employees/edit/${employee.employeeId}`}
                      className="flex items-center gap-4 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      <Pencil size={16} className="text-blue-500" /> Edit
                    </Link>
              
                    <button
                      onClick={() => handleInactive(employee._id,user)}
                      className="flex items-center gap-4 w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    >
                      <ShieldBan size={16} className="text-red-500" /> Inactive
                    </button>
                  </>
                ) : (
                  <button
                    onClick={() => handleActivate(employee._id,user)}
                    className="flex items-center gap-4 w-full text-left px-4 py-2 text-sm text-green-600 hover:bg-gray-100"
                  >
                    <CheckCircle size={16} className="text-green-500" /> Activate
                  </button>
                )}
              </div>
              
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
